import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
    selector: '[blackAccordianHeader]',
    standalone: false
})
export class AccordianHeaderDirective {  templateRef = inject<TemplateRef<any>>(TemplateRef);


}
